import { keyframes } from '@emotion/react'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import { Box } from '@mui/material'

const surge = keyframes`
  0% {
    opacity: 0.7;
    transform: scale(0.88) translateY(6px);
  }
  50% {
    opacity: 1;
    transform: scale(1.06) translateY(0);
  }
  100% {
    opacity: 0.7;
    transform: scale(0.88) translateY(6px);
  }
`

const SplashScreenPower = () => (
    <Box
        sx={{
            alignItems: 'center',
            backgroundColor: 'neutral.900',
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            left: 0,
            p: 3,
            position: 'fixed',
            top: 0,
            width: '100vw',
            zIndex: 2000
        }}
    >
        <ElectricBoltIcon
            sx={{
                animation: `${surge} 1s ease-in-out infinite`,
                color: 'primary.main',
                filter: (theme) =>
                    `drop-shadow(0 0 10px ${theme.palette.primary.main})`,
                fontSize: 110
            }}
        />
    </Box>
)

export default SplashScreenPower
